var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zhe-xian-tong-ji"},[_c('dv-border-box-12',[_c('div',{staticStyle:{"display":"flex","align-items":"center","height":"100%"}},[_c('div',{ref:"zhe_xian_tong_ji_echarts",staticStyle:{"width":"100%","height":"90%"}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }